import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import { StudentsView, studentsFiltersSchema } from '@/modules/students'
import { StudentsAndClassesView } from '@/modules/studentsAndClasses'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute('/_auth/students-and-classes/students/')({
  validateSearch: studentsFiltersSchema.parse,
  component: () => (
    <StudentsAndClassesView>
      <StudentsView />
    </StudentsAndClassesView>
  ),
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.students-and-classes', { ns: 'students' }),
      i18n.t('title.students', { ns: 'students' })
    ])
})
